import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * BrandContext — provides company/brand info (name, logo, colors) app-wide.
 * Anyone can update logo/name from Company Settings without touching code.
 */
const BrandCtx = createContext({
  brand: { name: "MY CHOICE TRADING LTD", logo_url: null, product: "MY PORTAL" },
  refresh: () => {},
});

export const BrandProvider = ({ children }) => {
  const [brand, setBrand] = useState({
    name: "MY CHOICE TRADING LTD",
    logo_url: null,
    product: "MY PORTAL",
  });
  const { user } = useAuth();

  const refresh = async () => {
    try {
      const { data } = await api.get("/company/settings");
      setBrand({
        name: data.name || "MY CHOICE TRADING LTD",
        logo_url: data.logo_url || null,
        product: "MY PORTAL",
        ...data,
      });
    } catch {
      /* not logged in yet — keep defaults */
    }
  };

  useEffect(() => {
    if (user && user.id) {
      refresh();
    }
    const onFocus = () => { if (user && user.id) refresh(); };
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
    // re-fetch on every login/user change
  }, [user?.id]);

  return (
    <BrandCtx.Provider value={{ brand, refresh }}>
      {children}
    </BrandCtx.Provider>
  );
};

export const useBrand = () => useContext(BrandCtx);
